// import throttle from 'lodash.throttle';
import TweenLite from "gsap/umd/TweenLite.js";
import React from 'react';
import styled from '@emotion/styled'
import { Grid } from 'style';
import { Media } from '..';



class GoertekSliderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      variableFontSupport: false,
      sliderValue: 50,
      letter: props.letter || 'E'
    }

    this.changed = this.changed.bind(this);

    // this.handleScroll = this.handleScroll.bind(this);

    // this.trottledScroll = throttle(this.handleScroll, 500);
    this.audioActive = false;

    this.letter = React.createRef();
    this.svg = React.createRef();
    this.action = React.createRef();
    this.frequency = React.createRef();

  }

  componentDidMount() {
    this.setState({ variableFontSupport: "fontVariationSettings" in document.documentElement.style }, this.setup);
  }

  componentWillUnmount() {
    this.tearDown();
  }

  addEvent(node, event_type, _options) {

    var options = _options || {};
    options.callback = options.callback || node["callback"];
    options.bubble = (options.bubble !== "undefined") ? false : true;

    node.addEventListener(event_type, (options.scope ? options.callback.bind(options.scope) : options.callback), options.bubble);
  }
  removeEvent(node, event_type, _options) {

    var options = _options || {};
    options.callback = options.callback || node["callback"];
    options.bubble = (options.bubble !== "undefined") ? false : true;

    node.removeEventListener(event_type, options.callback, options.bubble);
  }
  setup() {


    // references
    this.svg.current.path = this.svg.current.querySelector("path");
    this.svg.current.path.src = this.svg.current.getAttribute("data-path-src");

    // start svg morph
    if (!this.state.variableFontSupport) {
      this.svg.current.tween = TweenLite.to(this.svg.current.path, 1, { morphSVG: this.svg.current.path.src })
      this.svg.current.tween.pause();
    }

    // section build flag
    this.build = true;

    // slider feedback

    this.changed(50);

    // setup slider
    // this.addEvent(this.action.current, "input", { callback: this.action.current.changed, scope: this });

    // IE11 hack
    // this.addEvent(this.action.current, "change", { callback: this.action.current.changed, scope: this });
  }
  tearDown() {
    // this.removeEvent(this.action.current, "input", { callback: this.action.current.changed, scope: this });

    // IE11 hack
    // this.removeEvent(this.action.current, "change", { callback: this.action.current.changed, scope: this });
  }
  changed(event) {

    this.setState({ sliderValue: event.target ? event.target.value : event });
    var amount = event.target ? event.target.value : event;

    // update frequency
    this.frequency.current.innerHTML = amount + "%";

    if (this.state.variableFontSupport) {

      // update font vaue
      this.letter.current.style.setProperty("--elem-weight", amount);

    } else {

      // update morph
      this.svg.current.tween.progress(amount / 100);
    }
  }

  render() {
    const { variableFontSupport, sliderValue, letter } = this.state;
    const { media } = this.props;
    return (
      <Grid.Container>
        <Grid.Row wrap={'wrap'}>
          <LeftSide><Media image={media} /></LeftSide>
          <Slider className={[`visible`, variableFontSupport ? 'support' : 'default'].join(' ')}>

            <div className="content">
              <p ref={this.letter}>{letter}</p>

              <svg ref={this.svg} version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 134 140" data-path-src="M58.3,0h17.4l58,140h-18.9l-14.8-36.7L79,112l-24.3-10.5l-24.1,9.7L19.1,140H0.4L58.3,0z M67,21.5L38.4,92.1L55.2,85l24.1,10.5l15-6.3L67,21.5z">
                <path d="M58.3,0h17.4l58,140h-18.9l-15.8-39H79.2H54.8H34.9l-15.8,39H0.4L58.3,0z M67,21.5L41.6,84.4h13.2h24.4h13L67,21.5z" />
              </svg>

            </div>

            <ul className="action">
              <li>
                <input type="range" min="1" max="100" value={sliderValue} onChange={this.changed} ref={this.action} />
              </li>
            </ul>

            <dl>
              <dt>Volume:</dt>
              <dd ref={this.frequency}>0%</dd>
            </dl>
          </Slider>
        </Grid.Row>
      </Grid.Container>
    )
  }
}

const LeftSide = styled.div`
  width: 100%;

  @media (min-width: 1024px){
    max-width: 50%;
    flex: 1 1 50%;
  }
`;
const Slider = styled.div`


  position: relative;
  background-color: #000;
  color: #fff;
  width: 100%;
  padding: 30px;
  @media (min-width: 1024px){
    padding: 0 30px;
    max-width: calc(50% - 60px);
    flex: 1 1 50%;
  }

/* Goertek weights variables */
@font-face {
  font-family: "GoertekGX";
  src: url("/fonts/GoertekVariableGX.ttf") format("truetype-variations"),
    url("/fonts/GoertekVariableGX.ttf") format("truetype");
}

/* Goertek osci variables */
@font-face {
  font-family: "osciGX";
  src: url("/fonts/osciGX.ttf") format("truetype-variations"),
    url("/fonts/osciGX.ttf") format("truetype");
}

&.support h1,
&.support h1 span {
  font-family: "osciGX", Verdana, sans-serif;
  font-weight: 300;
}

ul, dl, dd, p{
  margin: 0;
  padding: 0;
  line-height: 1;
}
ul li {
  display: inline-block;
  vertical-align: top;
}
dl dt {display: none;}


/* global slider syling & reset */
input[type="range"] {-webkit-appearance: none; -webkit-tap-highlight-color: rgba(255, 255, 255, 0); width: 100%; height: 20px; margin: 0; border: none; padding: 0; background: transparent; outline: none;}
input[type="range"]::-moz-range-track {border: inherit; background: transparent;}
input[type="range"]::-ms-track {border: inherit; color: transparent; background: transparent;}
input[type="range"]::-ms-fill-lower,
input[type="range"]::-ms-fill-upper {background: transparent; height: 20px;}
input[type="range"]::-ms-tooltip {display: none;}
input[type="range"]::-webkit-slider-thumb {-webkit-appearance: none; background: transparent; width: 18px; height: 18px; border: none; border-radius: 20px; border: 1px solid #FFFFFF;}
input[type="range"]::-moz-range-thumb {width: 18px; height: 18px; border: none; border-radius: 20px; background: transparent; border: 1px solid #FFFFFF;}
input[type="range"]::-ms-thumb {width: 18px; height: 18px; border-radius: 20px; border: 1px solid #FFFFFF; background: transparent;}


  @media only screen and (max-width: 800px) {

input[type="range"] {-webkit-appearance: none; -webkit-tap-highlight-color: rgba(255, 255, 255, 0); height: 20px; margin: 0; border: none; padding: 0; background: transparent; outline: none;}
input[type="range"]::-moz-range-track {border: inherit; background: transparent;}
input[type="range"]::-ms-track {border: inherit; color: transparent; background: transparent;}
input[type="range"]::-ms-fill-lower,
input[type="range"]::-ms-fill-upper {background: transparent; height: 20px;}
input[type="range"]::-ms-tooltip {display: none;}
input[type="range"]::-webkit-slider-thumb {-webkit-appearance: none; background: transparent; width: 28px; height: 28px; border: none; border-radius: 30px; border: 1px solid #FFFFFF;}
input[type="range"]::-moz-range-thumb {width: 28px; height: 28px; border: none; border-radius: 30px; background: transparent; border: 1px solid #FFFFFF;}
input[type="range"]::-ms-thumb {width: 28px; height: 28px; border-radius: 30px; border: 1px solid #FFFFFF; background: transparent;}
}

.content {position: relative; padding-bottom: calc(50vw / 16 * 9 - 100px);}
&.support .content p {font-size: calc(50vw / 16 * 9 - 100px); line-height: 1em; color: #FFFFFF; position: absolute; top: 0; left: 0; right: 0; text-align: center;
	font-family: "osciGX", Verdana, sans-serif;
	font-variation-settings: "osci" var(--elem-weight);
	font-weight: 300;
}
&.default .content p {display: none;}
&.support .content svg {display: none;}
&.default .content svg {display: block; height: calc(50vw / 16 * 9 - 100px); position: absolute; top: 0; left: 0; right: 0; margin: 0 auto;}
&.default .content svg path {fill: #FFFFFF;}

 dl {position: absolute; top: 50px; right: 50px;}
 dl dt {font-size: 14px; line-height: 1em; text-transform: uppercase; color: #FFFFFF; display: inline-block; margin-right: 6px;}
 dl dd {font-size: 14px; line-height: 1em; text-transform: uppercase; color: #FFFFFF; display: inline-block; width: 26px;}

 ul.action {position: absolute; top: 10px; left: 50px; width: calc(50vw / 16 * 9 - 100px); height: 10px; border-top: 1px solid #FFFFFF; margin-top: 10px;
	-webkit-transform:rotate(90deg);
	-moz-transform:rotate(90deg);
	-o-transform:rotate(90deg);
	-ms-transform:rotate(90deg);
	transform:rotate(90deg);

	-webkit-transform-origin: 0 0;
	-moz-transform-origin: 0 0;
	-ms-transform-origin: 0 0;
	-o-transform-origin: 0 0;
	transform-origin: 0 0;
}
 ul.action li {width: 100%; font-size: 0; margin-top: -10px;}
 ul.action li input {width: 100%; cursor: pointer;}


/* start media query */
@media only screen and (max-width: 1400px) {

	.content {padding-bottom: calc(50vw / 16 * 9 - 60px);}
	&.support .content p {font-size: calc(50vw / 16 * 9 - 60px)}
	&.default .content p {}
	&.support .content svg {}
	&.default .content svg {height: calc(50vw / 16 * 9 - 60px);}
	&.default .content svg path {}
	 dl {top: 30px; right: 30px;}
	 dl dt {font-size: 12px;}
	 dl dd {font-size: 12px;}
	 ul.action {top: 40px; left: 60px; width: calc(50vw / 16 * 9 - 60px); margin-top: -10px;}
	 ul.action li {}
	 ul.action li input {}
}

@media only screen and (max-width: 1000px) {

	 .content {padding-bottom: calc(100vw / 16 * 9 - 60px);}
	&.support .content p {font-size: calc(100vw / 16 * 9 - 60px)}
	&.default .content p {}
	&.support .content svg {}
	&.default .content svg {height: calc(100vw / 16 * 9 - 60px);}
	&.default .content svg path {}
	 dl {}
	 dl dt {}
	 dl dd {}
	 ul.action {top: 50px; left: 60px; width: calc(100vw / 16 * 9 - 60px); margin-top: -10px;}
	 ul.action li {}
	 ul.action li input {}
}

@media only screen and (max-width: 800px) {

	 .content {padding-bottom: calc(100vw / 16 * 9 - 30px);}
	&.support .content p {font-size: calc(100vw / 16 * 9 - 60px)}
	&.default .content p {}
	&.support .content svg {}
	&.default .content svg {height: calc(100vw / 16 * 9 - 60px);}
	&.default .content svg path {}
	 dl {top: 30px; right: 10px;}
	 dl dt {font-size: 10px;}
	 dl dd {font-size: 10px;}
	 /* ul.action {top: auto; left: 10px; bottom: 20px; width: calc(100vw - 20px);
		-webkit-transform:rotate(0);
		-moz-transform:rotate(0);
		-o-transform:rotate(0);
		-ms-transform:rotate(0);
		transform:rotate(0)
	}
	 ul.action li {margin-top: -15px;}
	 ul.action li input {}	 */
}


`;

export default GoertekSliderComponent;
